<template>
    <div class="col-lg-4 col-sm-6 d-flex flex-column">
        <div class="card card-basic card--blue">
            <div class="card__image position-relative" :style="profileImage">
                <span v-if="member.imageUrl == null" class="card__initials">{{
                    member.initials
                }}</span>
            </div>
            <div class="card__text">
                <div class="card__text__top mx-auto">
                    <h2>{{ member.name }}</h2>
                    <ul class="mb-2 list-unstyled card__list font-italic">
                        <li>
                            {{ member.role }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        member: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        profileImage() {
            return [
                this.member.imageUrl == null
                    ? {
                          'background-color': '#F5F4F5'
                      }
                    : {
                          'background-image':
                              'url(' + this.member.imageUrl + ')'
                      }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
.card__image {
    height: 160px;
    width: 160px;
    margin: 20px auto 0 auto;
    background-size: cover;
    background-position: center center;
    border-radius: 90px;
}
</style>
